module.exports = __webpack_public_path__ + "static/media/tameimpala-currents.224925cf.jpg";